import { t } from "@/i18n-js/instance";
import { useCurrentCommunityContext } from "@circle-react/apps/AuthenticationApp";
import { getCsrfToken } from "@circle-react/components/OnboardingPage/helpers/methods";
import { authenticationAppRoutes } from "@circle-react/components/OnboardingPage/helpers/routes";
import { useIsNewOnboardingFlow } from "@circle-react/components/OnboardingPage/hooks/useIsNewOnboardingFlow";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { SOCIAL_PROVIDERS } from "./socialProviders";

interface SignupOptionsProps {
  trackStepCompleted?: (values: string[]) => void | Promise<void>;
  variant?: "signUp" | "signIn";
}

export const SignupOptions = ({
  trackStepCompleted,
  variant = "signUp",
}: SignupOptionsProps) => {
  const { currentCommunity } = useCurrentCommunityContext();
  const { isNewOnboardingFlow } = useIsNewOnboardingFlow();

  const handleSocialSubmit =
    (key: string) => async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      const form = e.currentTarget;
      try {
        if (trackStepCompleted) {
          await trackStepCompleted(["", "", key]);
        }
      } finally {
        setTimeout(() => {
          form.submit();
        }, 0);
      }
    };

  if (!isNewOnboardingFlow || currentCommunity) {
    return null;
  }

  const providerKeySuffix = variant === "signIn" ? "_sign_in" : "_sign_up";

  return (
    <>
      <div className="my-6 flex items-center">
        <div className="grow border-t border-gray-200" />
        <div className="mx-4">
          <Typography.LabelSm color="text-lightest" textTransform="lowercase">
            {t("or")}
          </Typography.LabelSm>
        </div>
        <div className="grow border-t border-gray-200" />
      </div>
      <div className="flex w-full flex-col gap-y-4">
        {SOCIAL_PROVIDERS.map(({ key, logo, translationKey }) => (
          <form
            key={key}
            method="POST"
            action={authenticationAppRoutes.socialSignIn(
              key,
              currentCommunity?.id,
            )}
            onSubmit={handleSocialSubmit(key)}
          >
            <input
              type="hidden"
              name="authenticity_token"
              value={getCsrfToken()}
            />
            <Button
              type="submit"
              full
              extraLarge
              className="flex items-center justify-start rounded-lg border border-gray-200 !bg-white !px-6 !py-4 hover:opacity-90"
            >
              <span className="flex size-4 items-center justify-center">
                <img
                  src={logo}
                  alt={t(`${translationKey}${providerKeySuffix}`)}
                  className="size-4"
                  loading="lazy"
                />
              </span>
              <span className="ml-3">
                <Typography.LabelMd>
                  {t(`${translationKey}${providerKeySuffix}`)}
                </Typography.LabelMd>
              </span>
            </Button>
          </form>
        ))}
      </div>
    </>
  );
};
